import axios from '@/utils/request'
import config from '@/config'
// 获取门店列表
export const getStoreList = (params)=>{
 return axios.request({
    url: 'v1/store/index',
    method: 'get',
    params
  })
};
// 门店列表导出
export const storeListExport = (params)=>{
  return axios.request({
     url: 'v1/store/export',
     method: 'get',
     params
   })
 };
// 获取连锁总店
export const getStoreChain= (params)=>{
  return axios.request({
     url: 'v1/store/select',
     method: 'get',
     params
   })
 };
//添加门店
export const storeAdd = (data)=>{
 return axios.request({
  url: 'v1/store/create',
  method: 'post',
  data
  })
};
// 获取门店详情
export const getStoreMore = (params)=>{
  return axios.request({
     url: 'v1/store/detail',
     method: 'get',
     params
  })
};
 // 修改门店
export const storeEdit = (data)=>{
  return axios.request({
     url: 'v1/store/save',
     method: 'post',
     data
  })
};
 // 删除门店
export const storeDel = (data)=>{
  return axios.request({
     url: 'v1/store/delete',
     method: 'post',
     data
  })
};
 // 修改门店状态
export const storeStatus = (data)=>{
  return axios.request({
     url: 'v1/store/status',
     method: 'post',
     data
  })
};
 // 获取门店审核列表
export const getStoreExamineList = (params)=>{
  return axios.request({
     url: 'v1/store_examine/index',
     method: 'get',
     params
  })
};
// 获取门店审核详情
export const getStoreExamineMore = (params)=>{
  return axios.request({
     url: 'v1/store_examine/detail',
     method: 'get',
     params
  })
};
// 门店审核
export const storeExamine = (data)=>{
  return axios.request({
     url: 'v1/store_examine/save',
     method: 'post',
     data
  })
};
// 获取门店成长值
export const getStorePurchase = (params)=>{
  return axios.request({
     url: 'v1/store_purchase/detail',
     method: 'get',
     params
  })
};
// 设置门店成长值
export const setStorePurchase = (data)=>{
  return axios.request({
     url: 'v1/store_purchase/save',
     method: 'post',
     data
  })
};
// 获取级别列表
export const getLevelList = (params)=>{
  return axios.request({
     url: 'v1/store_level/index',
     method: 'get',
     params
  })
};
export const getLevels=(params)=>{
  return axios.request({
    url: 'v1/store_level/getMaxLevelInfo',
    method: 'get',
    params
 })
}
// 添加级别
export const setlevelAdd = (data)=>{
  return axios.request({
     url: 'v1/store_level/create',
     method: 'post',
     data
  })
};
// 修改级别
export const levelEdit = (data)=>{
  return axios.request({
     url: 'v1/store_level/save',
     method: 'post',
     data
  })
};
// 删除级别
export const levelDel = (data)=>{
  return axios.request({
     url: 'v1/store_level/delete',
     method: 'post',
     data
  })
};
// 获取类型列表
export const getTypeList = (params)=>{
  return axios.request({
     url: 'v1/store_type/index',
     method: 'get',
     params
  })
};
// 添加类型
export const TypeAdd = (data)=>{
  return axios.request({
     url: 'v1/store_type/create',
     method: 'post',
     data
  })
};
// 修改类型
export const typeEdit = (data)=>{
  return axios.request({
     url: 'v1/store_type/save',
     method: 'post',
     data
  })
};
// 删除类型
export const typeDel = (data)=>{
  return axios.request({
     url: 'v1/store_type/delete',
     method: 'post',
     data
  })
};
// 生成链接
export const getInviteRegistered = (data)=>{
  return axios.request({
     url: 'v1/store/getInviteRegistered',
     method: 'post',
     data
  })
};

// 下载核销码包
export const downloadPackage = (data)=>{
  return axios.request({
     url: 'v1/store_wiped/downloadPackage',
     method: 'post',
     data
  })
};

// 获取核销码base64格式
export const getBaseEncode = (params)=>{
  return axios.request({
     url: 'v1/store_wiped/getBaseEncode',
     method: 'get',
     params
  })
};
// 门店核销码-列表
export const getstoreWipedList = (params)=>{
  return axios.request({
     url: 'v1/store_wiped/index',
     method: 'get',
     params
  })
};
// 门店成长值明细-列表
export const getStoreGrowthValueLog = (params)=>{
  return axios.request({
     url: 'v1/store/growthValueLog',
     method: 'get',
     params
  })
};
// 更新门店成长值
export const setGrowthValue = (data)=>{
  return axios.request({
     url: 'v1/store/growthValue/'+data.id,
     method: 'post',
     data
  })
};
// 门店返利设置列表
export const getStoreRebate = (params)=>{
  return axios.request({
     url: 'v1/storeRebate/setting',
     method: 'get',
     params
  })
};
// 门店返利设置
export const setStoreRebate = (data)=>{
  return axios.request({
     url: 'v1/storeRebate/setting',
     method: 'post',
     data
  })
};
// 门店推广积分明细
export const getStoreRebateLog = (params)=>{
  return axios.request({
     url: 'v1/storeRebate/log',
     method: 'get',
     params
  })
};

// 获取-通用-级别列表
export const getPublicLevelList = (params)=>{
  return axios.request({
     url: 'v1/public/storeLevel',
     method: 'get',
     params
  })
};
// 获取-通用-类型列表
export const getPublicTypeList = (params)=>{
  return axios.request({
     url: 'v1/public/storeType',
     method: 'get',
     params
  })
};
// 门店送积分
export const toPoint = (data)=>{
  return axios.request({
     url: 'v1/store/toPoint',
     method: 'post',
     data
  })
};
// 门店送红包
export const toRedEnvelope = (data)=>{
  return axios.request({
     url: 'v1/store/toRedEnvelope',
     method: 'post',
     data
  })
};

// 门店发放积分明细
export const pointList = (params)=>{
  return axios.request({
     url: '/v1/store/pointList',
     method: 'get',
     params
  })
};

// 批量导入门店
export const storeImport = (data)=>{
  return config.baseUrl[process.env.VUE_APP_type]+'v1/store/import'
};

// 下载导入门店
export const storeExcel = (params)=>{
  return axios.request({
    url: 'storeExcel',
    method: 'get',
    params
 })
};
// 修改密码
export const changePassword = (data)=>{
  return axios.request({
     url:'v1/store/changePassword',
     method: 'POST',
     data
  })
};

/**
 * 
 * 模板设置v2.0
 */

// 门店菜单数据获取
export const getStoreTemplateMenu = (params)=>{
  return axios.request({
    url: 'v2/store/menu',
    method: 'get',
    params
  })
};
// 门店后台首页设置
export const setStoreTemplateMenu = (data)=>{
  return axios.request({
    url: 'v2/store/menuConfig',
    method: 'post',
    data
  })
};
// 门店常用功能-添加获取菜单数据
export const getStoreUsedMenu = (params)=>{
  return axios.request({
    url: 'v2/store/menuListsOftenUse',
    method: 'get',
    params
  })
};
// 门店常用功能获取
export const getStoreTemplateUsed = (params)=>{
  return axios.request({
    url: 'v2/store/oftenUseMenu',
    method: 'get',
    params
  })
};
// 门店常用功能添加
export const setStoreTemplateUsed = (data)=>{
  return axios.request({
    url: 'v2/store/oftenUseMenu',
    method: 'post',
    data
  })
};

// 门店推广统计
export const getChannelStore = ( params) => {
  return axios.request({
    url: 'v2/channel/store',
    method: 'get',
    params
  })
};
// 门店推广统计详情
export const getChannelStoreDetail = ( params) => {
  return axios.request({
    url: 'v2/channel/store/detail',
    method: 'get',
    params
  })
};
// 门店导购积分明细
export const ShoppingGuideList = (params)=>{
  return axios.request({
     url: '/v2/storeClerk/pointLog',
     method: 'get',
     params
  })
};
// 门店级别-系统配置详情
export const getset = ()=>{
  return axios.request({ 
    url: 'v2/store/configDetail',
    method: 'get',
    
  })
};
// 门店级别-系统配置保存
export const editset = (data)=>{
  return axios.request({
    url: 'v2/store/config',
    method: 'post',
    data
  })
};